@if (user) {
  <hawk-record-navigation
    class="app-page"
    [breadcrumbLinkList]="[{ link: '/a/benutzer', description: 'Nutzer' }]"
    [root]="'user'"
    [leafDescription]="user?.full_name || ''"
  >
    <div slot="toolbar" class="flex flex-row gap-2 items-center">
      <a [routerLink]="'/benutzer/' + user.id + '/bearbeiten'" class="bm-btn bm-btn-ghost">
        <fa-icon [icon]="faEdit"></fa-icon>
        Bearbeiten
      </a>
      <a [routerLink]="'/benutzer/' + user.id + '/passwort'" class="bm-btn bm-btn-ghost">
        <fa-icon [icon]="faKey"></fa-icon>
        Passwort
      </a>
      <button (click)="toggleUserActivation()" class="bm-btn bm-btn-ghost">
        {{ user.active ? "Deaktivieren" : "Aktivieren" }}
      </button>
      <span
        [class.bm-tooltip]="!userIsDeletable"
        class="bm-tooltip-left"
        [attr.data-tip]="
          'Nutzer können nur gelöscht werden, wenn keine Abhängigkeiten zu Lagern, Aufträgen, Platzhalter Technikern, Angestellten, (Dispatcher) Projekten, und QM-Jobs vorhanden sind'
        "
      >
        <button [disabled]="!userIsDeletable" (click)="deleteUser()" class="bm-btn bm-btn-error">
          <fa-icon [icon]="faTrash"></fa-icon>
          Löschen
        </button>
      </span>
    </div>
    <div class="page-content page-frame overflow-auto">
      <div class="page-sheet max-w-7xl mx-auto grid grid-cols-3 gap-4">
        <div class="bm-card bm-card-sm row-span-3 border border-base-300">
          <ng-container [ngTemplateOutlet]="tplMap" />
          <div class="bm-card-body">
            <div class="bm-card-title">Kontaktdaten</div>
            <ng-container [ngTemplateOutlet]="tplKontaktdaten" />
          </div>
        </div>
        <div class="bm-card bm-card-sm border border-base-300">
          <div class="bm-card-body">
            <div class="bm-card-title">Adresse</div>
            <ng-container [ngTemplateOutlet]="tplAdresse" />
          </div>
        </div>
        <div class="bm-card bm-card-sm border border-base-300">
          <div class="bm-card-body">
            <div class="bm-card-title">Firmenadresse</div>
            <ng-container [ngTemplateOutlet]="tplFirmenAdresse" />
          </div>
        </div>
        <div class="bm-card bm-card-sm border border-base-300">
          <div class="bm-card-body">
            <div class="bm-card-title">Sonstiges</div>
            <ng-container [ngTemplateOutlet]="tplSonstiges" />
          </div>
        </div>
        <div class="bm-card bm-card-sm border border-base-300">
          <div class="bm-card-body">
            <div class="bm-card-title">Nutzerrollen</div>
            <ng-container [ngTemplateOutlet]="tplNutzerrollen" />
            @if (user.dispatcher_color) {
              <div class="border-t border-base-300 mt-3 pt-3">
                <div class="text-xs text-base-content/60 mb-1">Dispatcher-Farbe</div>
                <div class="flex flex-row items-center gap-2">
                  <span
                    class="inline-block w-6 h-6 rounded border border-base-300"
                    [style.background-color]="user.dispatcher_color"
                  ></span>
                  <span class="text-sm font-mono">{{ user.dispatcher_color }}</span>
                </div>
              </div>
            }
            @if (user.tour_color) {
              <div class="border-t border-base-300 mt-3 pt-3">
                <div class="text-xs text-base-content/60 mb-1">Tourfarbe</div>
                <div class="flex flex-row items-center gap-2">
                  <span
                    class="inline-block w-6 h-6 rounded border border-base-300"
                    [style.background-color]="user.tour_color"
                  ></span>
                  <span class="text-sm font-mono">{{ user.tour_color }}</span>
                </div>
              </div>
            }
          </div>
        </div>
        <div class="col-span-2">
          <ng-container [ngTemplateOutlet]="tplTabs" />
        </div>
      </div>
    </div>
  </hawk-record-navigation>
}

<ng-template #tplKontaktdaten>
  <dl class="bm-dl gap-x-2">
    <dt>E-Mail</dt>
    <dd>
      <a class="bm-link bm-link-hover" [href]="'mailto:' + user.email1">{{ user.email1 }}</a>
    </dd>
    <dt>Zusätzliche E-Mail</dt>
    <dd>
      <a class="bm-link bm-link-hover" [href]="'mailto:' + user.email2">{{ user.email2 }}</a>
    </dd>
    <dt>E-Mail MoreApp</dt>
    <dd>
      <a class="bm-link bm-link-hover" [href]="'mailto:' + user.email_moreapp">{{ user.email_moreapp }}</a>
    </dd>
    <dt>Kunde</dt>
    <dd>
      @if (user.customer) {
        <a class="bm-link bm-link-hover" [routerLink]="'/kunde/' + user.customer.id">
          <fa-icon [icon]="faIndustry"></fa-icon>
          {{ user.customer.name }}
        </a>
      } @else {
        -
      }
    </dd>
    <dt>Telefon (Beruflich)</dt>
    <dd>
      @if (user.phone1) {
        <a class="bm-link bm-link-hover" [href]="'phone:' + user.phone1">
          <fa-icon [icon]="faPhone"></fa-icon>
          {{ user.phone1 }}
        </a>
      }
    </dd>
    <dt>Telefon (Privat)</dt>
    <dd>
      @if (user.phone2) {
        <a class="bm-link bm-link-hover" [href]="'phone:' + user.phone2">
          <fa-icon [icon]="faPhone"></fa-icon>
          {{ user.phone2 }}
        </a>
      }
    </dd>
    <dt>Telefon für Dispatching</dt>
    <dd>
      @if (user.telephone_dispatching) {
        <a class="bm-link bm-link-hover" [href]="'phone:' + user.telephone_dispatching">
          <fa-icon [icon]="faPhone"></fa-icon>
          {{ user.telephone_dispatching }}
        </a>
      }
    </dd>
    <dt>Weitere Kontaktinformationen</dt>
    <dd>
      {{ user.more_contact_info }}
    </dd>
    <dt>Partner E-Mail</dt>
    <dd>
      <a class="bm-link bm-link-hover" [href]="'mailto:' + user.email_partner1">{{ user.email_partner1 }}</a>
    </dd>
    <dt>Zusätzliche Partner E-Mail</dt>
    <dd>
      <a class="bm-link bm-link-hover" [href]="'mailto:' + user.email_partner2">{{ user.email_partner2 }}</a>
    </dd>
  </dl>
</ng-template>

<ng-template #tplAdresse>
  <dl class="bm-dl gap-x-2">
    <dt>Firma</dt>
    <dd>{{ user.company }}</dd>
    <dt>Straße</dt>
    <dd>{{ user.street }}</dd>
    <dt>PLZ und Ort</dt>
    <dd>{{ user.zip }} {{ user.city }}</dd>
    <dt>Land (Staat)</dt>
    <dd>
      {{ user.country }}
      @if (user.state) {
        ({{ user.state }})
      }
    </dd>
  </dl>
</ng-template>
<ng-template #tplFirmenAdresse>
  <dl class="bm-dl gap-x-2">
    <dt>Firma</dt>
    <dd>{{ user.company_address_company }}</dd>
    <dt>Name</dt>
    <dd>{{ user.company_address_name }}</dd>
    <dt>Straße</dt>
    <dd>{{ user.company_address_street }}</dd>
    <dt>PLZ und Ort</dt>
    <dd>{{ user.company_address_zip }} {{ user.company_address_city }}</dd>
    <dt>Land (Staat)</dt>
    <dd>
      {{ user.company_address_country }}
      @if (user.company_address_state) {
        ({{ user.company_address_state }})
      }
    </dd>
  </dl>
</ng-template>
<ng-template #tplSonstiges>
  <dl class="bm-dl gap-x-2">
    <dt>Angestellt bei</dt>
    <dd>
      @if (user.employer) {
        <a class="bm-link bm-link-hover" [routerLink]="'/benutzer/' + user.employer.id">
          <fa-icon [icon]="faUser"></fa-icon>
          {{ user.employer.name }}
        </a>
      } @else {
        -
      }
    </dd>
    <dt>Versandfiliale</dt>
    <dd>
      @if (user.internal_shipping_store) {
        <a class="bm-link bm-link-hover" [routerLink]="'/filiale/' + user.internal_shipping_store.id">
          <fa-icon [icon]="faStore"></fa-icon>
          {{ user.internal_shipping_store.name }}
        </a>
      } @else {
        -
      }
    </dd>
    <dt>Packstation Karten-Nr</dt>
    <dd>{{ user.card_nr_packstation }}</dd>
    <dt>Pickpoint-Nr</dt>
    <dd>{{ user.pickpoint_nr }}</dd>
    <dt>XML-ID</dt>
    <dd>{{ user.xml_id }}</dd>
    <dt>Bekommt Rückversandtickets</dt>
    <dd>{{ (user.receives_return_tickets ?? true) ? "Ja" : "Nein" }}</dd>
    <!-- Instandsetzerkennzeichen fürs Eichamt (siehe bentomax/hawk#574) -->
    <dt>Instandsetzerkennzeichen</dt>
    <dd>{{ user.verification_repairer_code || "-" }}</dd>
    <dt>Notizen</dt>
    <dd>{{ user.comment }}</dd>
  </dl>
</ng-template>

<ng-template #tplNutzerrollen>
  <div class="flex flex-row flex-wrap rounded-full gap-1">
    @for (role of user.roles; track $index) {
      @if (!role.name.includes("CRM")) {
        <span class="bm-badge bm-badge-accent">{{ role.name }}</span>
      }
    }
  </div>
  @if (user.app_config && hasActiveAppConfig()) {
    <div class="bm-card-title mt-4">App-Konfiguration</div>
    <div class="flex flex-row flex-wrap gap-1">
      @if (user.app_config["show_debug"]) {
        <span class="bm-badge bm-badge-info">Debug-Ausgaben</span>
      }
      @if (user.app_config["request_log_upload"]) {
        <span class="bm-badge bm-badge-warning">Log-Upload angefordert</span>
      }
      @if (user.app_config["disable_checklist_validation"]) {
        <span class="bm-badge bm-badge-error">Checklisten-Validierung deaktiviert</span>
      }
    </div>
  }
</ng-template>

<ng-template #tplMap>
  @if (user.lat && user.lng) {
    <mgl-map
      [style]="'mapbox://styles/mapbox/streets-v9'"
      [zoom]="[6]"
      [center]="[user.lng, user.lat]"
      [scrollZoom]="ctrlIsPressed"
      class="aspect-video"
    >
      <mgl-marker [lngLat]="[user.lng, user.lat]">
        <div
          class="marker"
          [style.borderColor]="'black'"
          [style.backgroundColor]="'#af0000'"
          title="{{ user.full_name }}"
        ></div>
      </mgl-marker>
    </mgl-map>
  }
</ng-template>

<ng-template #tplTabs>
  <div role="tablist" class="bm-tabs bm-tabs-lift w-full">
    <a role="tab" class="bm-tab" [class.bm-tab-active]="tabId === 'warehouses'" (click)="tabId = 'warehouses'">
      Lager ({{ user.warehouses.length }})
    </a>
    @if (tabId === "warehouses") {
      <div class="bm-tab-content bg-base-100 border-t-base-300 pt-3">
        <table class="bm-table bm-table-xs">
          @for (item of user.warehouses; track $index) {
            <tr>
              <td>
                <a class="bm-link bm-link-hover" [routerLink]="'/lager/' + item.id" target="_blank">
                  {{ item.label }}
                </a>
              </td>
            </tr>
          }
        </table>
      </div>
    }

    <a role="tab" class="bm-tab" [class.bm-tab-active]="tabId === 'projects'" (click)="tabId = 'projects'">
      Dispatcher Projekte ({{ user.dispatcher_projects.length }})
    </a>
    @if (tabId === "projects") {
      <div class="bm-tab-content bg-base-100 border-t-base-300 pt-3">
        <label class="bm-fieldset-label">
          <input type="checkbox" class="bm-checkbox" [(ngModel)]="showOnlyActiveProjects" />
          Nur aktive Projekte
        </label>
        <table class="bm-table bm-table-xs w-full">
          @for (project of user.dispatcher_projects; track $index) {
            @if (project.active || !showOnlyActiveProjects) {
              <tr>
                <td>
                  <a class="bm-link bm-link-hover" [href]="'/project/' + project.id + '/show'" target="_blank">
                    Hawk 1.0
                  </a>
                </td>
                <td>
                  <a class="bm-link bm-link-hover" [routerLink]="'/projekt/' + project.id" target="_blank">
                    <fa-icon [icon]="faProductHunt"></fa-icon>
                    {{ project.name }}
                  </a>
                </td>
              </tr>
            }
          }
        </table>
      </div>
    }
    <a role="tab" class="bm-tab" [class.bm-tab-active]="tabId === 'employees'" (click)="tabId = 'employees'">
      Angestellte ({{ user.employees.length }})
    </a>
    @if (tabId === "employees") {
      <div class="bm-tab-content bg-base-100 border-t-base-300 pt-3">
        <table class="w-full bm-table bm-table-xs">
          @for (employee of user.employees; track $index) {
            <tr>
              <td>
                <a class="bm-link bm-link-hover" [routerLink]="'/benutzer/' + employee.id" target="_blank">
                  <fa-icon [icon]="faUser"></fa-icon>
                  {{ employee.name }}
                </a>
              </td>
            </tr>
          }
        </table>
      </div>
    }
  </div>
</ng-template>
